import { LogEvent } from 'src/app/interfaces/log';
import { EventLoggingParams, LogEventKey } from '../../../interfaces/log';
import { LogService } from '../log.service';
import { SurveyCommonParams } from './survey-log';

export class SurveyLogService {
  constructor(private logService: LogService) {

  }

  private commonParams: SurveyCommonParams | undefined;

  setSurveyCommonParams(params: SurveyCommonParams): void {
    if (this.commonParams === undefined) {
      this.commonParams = { ...params }
    } else {
      this.commonParams = { ...this.commonParams, ...params };
    }
  }

  surveyResultViewed(params: EventLoggingParams): void {
    this.eventLogging(LogEvent.SURVEY_RESULT_VIEWED, params)
  }
  homeSurveyAnswerClicked(params: EventLoggingParams): void {
    this.eventLogging(LogEvent.HOME_SURVEY_ANSWER_CLICKED, params);
  }
  homeSurveyAnswerPosted(params: EventLoggingParams): void {
    this.eventLogging(LogEvent.HOME_SURVEY_ANSWER_POSTED, params);
  }
  surveyResultSurveyAnswerPosted(params: EventLoggingParams): void {
    this.eventLogging(LogEvent.SURVEY_RESULT_SURVEY_ANSWER_POSTED, params);
  }
  homeSurveyAnswerUpdated(params: EventLoggingParams): void {
    this.eventLogging(LogEvent.HOME_SURVEY_ANSWER_UPDATED, params);
  }
  surveyResultSurveyAnswerUpdated(params: EventLoggingParams): void {
    this.eventLogging(LogEvent.SURVEY_RESULT_SURVEY_ANWER_UPDATED, params);
  }
  homeSurveyImpression(params: EventLoggingParams): void {
    this.eventLogging(LogEvent.HOME_SURVEY_IMPRESSION, params);
  }
  surveyResultDismiss(params: EventLoggingParams): void {
    this.eventLogging(LogEvent.SURVEY_RESULT_DISMISS, params);
  }
  homeSurveyResultClick(params: EventLoggingParams): void {
    this.eventLogging(LogEvent.HOME_SURVEY_RESULT_CLICK, params);
  }

  // [메인 - 서베이] ‘댓글 남기기’ 버튼 클릭		
  homeSurveyCommentWriteClicked(): void {
    this.eventLogging(LogEvent.HOME_SURVEY_COMMENT_WRITE_CLICKED);
  }
  // [메인 - 서베이] ‘댓글 모두 보기’ 버튼 클릭		
  homeSurveyShowAllComments(): void {
    this.eventLogging(LogEvent.HOME_SURVEY_SHOW_ALL_COMMENTS);
  }
  // [서베이 결과모달] 댓글 삭제
  surveyResultCommentsDeleted(commentId: number): void {
    this.eventLogging(LogEvent.SURVEY_RESULT_COMMENTS_DELETED, { commentId });
  }

  surveyResultCommentsReported(commentId: number): void {
    this.eventLogging(LogEvent.SURVEY_RESULT_COMMENTS_REPORTED, { commentId });
  }

  // [서베이 결과모달] 댓글 영역 노출
  surveyResultCommentsImpression(): void {
    this.eventLogging(LogEvent.SURVEY_RESULT_COMMENTS_IMPRESSION);
  }
  // [서베이 결과모달] 댓글 작성 		
  surveyResultCommentSubmitClicked(): void {
    this.eventLogging(LogEvent.SURVEY_RESULT_COMMENT_SUBMIT_CLICKED);
  }
  // [서베이 결과모달] 댓글 작성을 위한 키보드 열기		
  surveyResultKeyboardOpened(): void {
    this.eventLogging(LogEvent.SURVEY_RESULT_KEYBOARD_OPENED);
  }
  // [서베이 결과모달] 댓글의 ‘라이크’ 눌러서 지정함
  surveyResultCommentLikeSetClicked(commentId: number): void {
    this.eventLogging(LogEvent.SURVEY_RESULT_COMMENT_LIKE_SET_CLICKED, { commentId });
  }
  // [서베이 결과모달] 댓글의 ‘라이크’ 눌러서 해제함
  surveyResultCommentLikeUnsetClicked(commentId: number): void {
    this.eventLogging(LogEvent.SURVEY_RESULT_COMMENT_LIKE_UNSET_CLICKED, { commentId });
  }
  // [서베이 결과모달] 모든유형보기(…) 버튼 클릭
  surveyResultSummarySeeAllClicked(): void {
    this.eventLogging(LogEvent.SURVEY_RESULT_SUMMARY_SEE_ALL_CLICKED);
  }
  // TODO: [서베이 결과모달] 유형별 결과 좌우 스크롤
  surveyResultSummaryScrolled(): void {
    this.eventLogging(LogEvent.SURVEY_RESULT_SUMMARY_SCROLLED);
  }

  //exp-041
  surveyResultClickShowAllButton(toggle: 'open' | 'close'): void {
    this.eventLogging(LogEvent.SURVEY_RESULT_CLICK_SHOW_ALL_BUTTON, { toggle });
  }
  surveyResultHotSurveyClicked(surveyContent: string | undefined): void {
    this.eventLogging(LogEvent.SURVEY_RESULT_HOT_SURVEY_CLICKED, { surveyContent });
  }
  surveyResultLoginModalViewed(): void {
    this.eventLogging(LogEvent.SURVEY_RESULT_LOGIN_MODAL_VIEWED);
  }
  surveyResultAllSurveyButtonClicked(): void {
    this.eventLogging(LogEvent.SURVEY_RESULT_ALL_SURVEY_BUTTON_CLICKED);
  }
  surveyResultShareButtonClicked(type: 'kakao' | 'copy', location: 'top' | 'bottom' | undefined): void {
    this.eventLogging(LogEvent.SURVEY_RESULT_SHARE_BUTTON_CLICKED, { type, location });
  }
  surveyClickCommment(commentCount: number): void {
    this.eventLogging(LogEvent.SURVEY_CLICK_COMMENT, { commentCount });
  }
  surveyResultImpression(surveyId: string | null): void {
    this.eventLogging(LogEvent.SURVEY_RESULT_IMPRESSION, { surveyId });
  }
  surveyResultClickResultButton(): void {
    this.eventLogging(LogEvent.SURVEY_RESULT_CLICK_RESULT_BUTTON);
  }
  surveyResultClickAnswer(params: EventLoggingParams): void {
    this.eventLogging(LogEvent.SURVEY_RESULT_CLICK_ANSWER, { params })
  }
  surveyUpdateClickAnswer(params: EventLoggingParams): void {
    this.eventLogging(LogEvent.SURVEY_RESULT_UPDATE_ANSWER, { params })
  }

  private eventLogging(event: LogEventKey, params?: EventLoggingParams): void {
    this.logService.eventLogging(event, {
      ...this.commonParams,
      ...params
    })
  }
}